import { FC, ReactElement } from "react";

const Warning:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M28.359 23.597l-10.784-17.45c-0.869-1.403-2.281-1.406-3.15 0v0l-10.784 17.45c-1.166 1.884-0.319 3.403 1.888 3.403h20.944c2.203 0 3.050-1.522 1.887-3.403zM16 24c-0.553 0-1-0.447-1-1s0.447-1 1-1 1 0.447 1 1-0.447 1-1 1zM17 19.003c0 0.544-0.447 0.997-1 0.997-0.556 0-1-0.447-1-0.997v-6.006c0-0.544 0.447-0.997 1-0.997v0c0.556 0 1 0.447 1 0.997v6.006z"></path>
        </svg>
    )
}

export default Warning;